import TableNoDataWithFiltersComponent from './tableNoDataWithFiltersComponent';

export default TableNoDataWithFiltersComponent;
